export enum ApiErrorMessage {
  WrongPassword = 'Wrong password',
  UserNotFound = 'User not found',
  EmailNotFound = 'Email not found',
  UserExists = 'User already exists',
  EmailAlreadyInUse = 'Email already in use',
  TokenNotFound = 'Token not found',
  TokenExpiredError = 'Token expired',
}
